import { render, staticRenderFns } from "./PoiRecords.vue?vue&type=template&id=8b991b72&scoped=true"
import script from "./PoiRecords.vue?vue&type=script&lang=js"
export * from "./PoiRecords.vue?vue&type=script&lang=js"
import style0 from "./PoiRecords.vue?vue&type=style&index=0&id=8b991b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b991b72",
  null
  
)

export default component.exports